import React from "react";
import { createBrowserRouter } from "react-router-dom";
import { App } from "@/components/App/App";
import { MainPage } from "@/pages/main/MainPage";
import { NotFound } from "@/pages/notFound/NotFound";
import { Auth } from "@/components/App/Auth";
import Wrapper from "@/components/App/Wrapper";
import ProtectedRoute from "@/components/ProtectedRoute/ProtectedRoute";

const routes = [
  {
    element: <Wrapper />,
    children: [
      {
        element: <Auth />,
        children: [
          {
            path: "/login",
            lazy: () =>
              import("@/pages/auth/LoginPage").then((page) => ({
                Component: page.default,
              })),
          },
          {
            path: "/register",
            lazy: () =>
              import("@/pages/auth/RegisterPage").then((page) => ({
                Component: page.default,
              })),
          },
          {
            path: "/reset-password",
            lazy: () =>
              import("@/pages/auth/ResetPassword").then((page) => ({
                Component: page.default,
              })),
          },
          {
            path: "/set-new-password",
            lazy: () =>
              import("@/pages/auth/SetNewPassword").then((page) => ({
                Component: page.default,
              })),
          },
          {
            path: "/otp",
            lazy: () =>
              import("@/pages/auth/OtpNavigation").then((page) => ({
                Component: page.default,
              })),
          },
          {
            path: "/*",
            element: <NotFound />,
          },
        ],
      },
      {
        element: <Auth ignoreAuth />,
        children: [
          {
            path: "/logout",
            lazy: () =>
              import("@/pages/auth/LogoutPage").then((page) => ({
                Component: page.default,
              })),
          },
          {
            path: "/change-password",
            lazy: () =>
              import("@/pages/auth/ChangePassword").then((page) => ({
                Component: page.default,
              })),
          },
        ],
      },
      {
        element: <App />,
        children: [
          {
            element: <ProtectedRoute />,
            children: [
              {
                path: "/profile",
                lazy: () =>
                  import("@/pages/user/Profile").then((page) => ({
                    Component: page.default,
                  })),
              },
              {
                path: "/pets/create",
                lazy: () =>
                  import("@/pages/pet/PetProfileCreatePage").then((page) => ({
                    Component: page.default,
                  })),
              },
              {
                path: "/pets/:id/edit",
                lazy: () =>
                  import("@/pages/pet/PetProfileEditPage").then((page) => ({
                    Component: page.default,
                  })),
              },
            ],
          },
          {
            path: "/",
            element: <MainPage />,
          },
          {
            path: "/faq",
            lazy: () =>
              import("@/pages/faq/Faq").then((page) => ({
                Component: page.Faq,
              })),
          },
          {
            path: "/about-us",
            lazy: () =>
              import("@/pages/aboutUs/AboutUs").then((page) => ({
                Component: page.AboutUs,
              })),
          },
          {
            path: "/blog",
            lazy: () =>
              import("@/pages/blog/Blog").then((page) => ({
                Component: page.Blog,
              })),
          },
          {
            path: "/blog/:id",
            lazy: () =>
              import("@/pages/blog/ArticlePage").then((page) => ({
                Component: page.ArticlePage,
              })),
          },
          {
            path: "/blog/how-to-support-yourself",
            lazy: () =>
              import("@/pages/blog/PdfPage").then((page) => ({
                Component: page.PdfPage,
              })),
          },
          {
            path: "/pets/:id",
            lazy: () =>
              import("@/pages/pet/PetProfile/PetProfile").then((page) => ({
                Component: page.default,
              })),
          },
          {
            path: "/privacy-policy",
            lazy: () =>
              import("@/pages/documents/PrivacyPolicyPage").then((page) => ({
                Component: page.PrivacyPolicyPage,
              })),
          },
          {
            path: "/public-agreement",
            lazy: () =>
              import("@/pages/documents/PublicAgreementPage").then((page) => ({
                Component: page.PublicAgreementPage,
              })),
          },
          {
            path: "/personal-data-consent",
            lazy: () =>
              import(
                "@/pages/documents/PersonalDataConsentPage"
              ).then((page) => ({ Component: page.PersonalDataConsentPage })),
          },
          {
            path: "/personal-data-policy",
            lazy: () =>
              import(
                "@/pages/documents/PersonalDataPolicyPage"
              ).then((page) => ({ Component: page.PersonalDataPolicyPage })),
          },
          {
            path: "/user-agreement",
            lazy: () =>
              import("@/pages/documents/UserAgreementPage").then((page) => ({
                Component: page.UserAgreementPage,
              })),
          },
        ],
      },
      {
        path: "/playground",
        lazy: () =>
          import("@/pages/playground/PlaygroundPage").then((page) => ({
            Component: page.PlaygroundPage,
          })),
      },
      {
        path: "/sky",
        lazy: async () => {
          const { FirefliesNightPage } = await import(
            "@/pages/firefliesNight/FirefliesNightPage"
          );
          return { Component: FirefliesNightPage };
        },
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
